// extracted by mini-css-extract-plugin
export default {"modalHeader":"modalHeader__oRiTLF","modal":"modal__WfFvMY","twoPanel":"twoPanel__k_7xf9","historyPanel":"historyPanel__iV307T","detailPanel":"detailPanel__UIQQ8G"};